export const iconFontAwesomeDisasterCrisisSnowflake = (
	<i className="fa-solid fa-snowflake"></i>
);
